define('viewModels/AppMain',[
    'lib/knockout',
    'lib/lodash4',
    'config',
    'services/authService',
    'services/userService',
    'services/routeService',
    'viewModels/ViewModel',
    'viewModels/HelpMenu',
    'viewModels/PrivilegedMain',
    'viewModels/QueuesSelectView',
    'viewModels/SwitchedView',
    'viewModels/TreeNav',
    'viewModels/MyAccount',
    'viewModels/primaryNav'
], function (
    ko,
    _,
    config,
    authService,
    userService,
    routeService,
    ViewModel,
    HelpMenu,
    PrivilegedMain,
    QueuesSelectView,
    SwitchedView,
    TreeNav,
    MyAccount,
    primaryNav
) {
    'use strict';

    var AppMain = ViewModel.extend(function () {
        var self = this;

        self.showNavLink = ko.computed(function () {
            var navLinkRolesAndPermissions = getNavLinkRolesAndPermissions(primaryNav.entries());
            return authService.hasAnyAuthorization(navLinkRolesAndPermissions);
        });

        self.showPrivilegedNav = ko.observable(false);

        // Flag that enables close animation. We don't want to animate
        // the close on the intial render.
        self.hasToggledPrivilegedNav = ko.observable(false);

        self.helpMenu = self.subView(HelpMenu);

        self.breadcrumbs = routeService.breadcrumbsNav;

        /**
         * These are the main application area views.
         */
        self.subViews = self.subView(SwitchedView, {
            privilegedView: PrivilegedMain,
            queuesSelectView: QueuesSelectView,
            myAccount: MyAccount
        });

        self.togglePrivilegedNav = function () {
            self.showPrivilegedNav(!self.showPrivilegedNav());
            self.hasToggledPrivilegedNav(true);
        };

        self.privilegedNav = self.subView(TreeNav, primaryNav.entries);

        //Close the nav on navigation events
        self.computed(function () {
            routeService.route();
            self.showPrivilegedNav(false);
        });
    });

    //Calculates which roles and permissions can view the nav menu based on the primaryNav
    function getNavLinkRolesAndPermissions(data) {
        return _.unique(
            data.reduce(function (rolesAndPermissions, linkData) {
                rolesAndPermissions = rolesAndPermissions.concat(linkData.roles || []);
                rolesAndPermissions = rolesAndPermissions.concat(linkData.permissions || []);
                if(linkData.subLinks) {
                    rolesAndPermissions = rolesAndPermissions.concat(getNavLinkRolesAndPermissions(linkData.subLinks));
                }
                return rolesAndPermissions;
            }, [])
        );
    }

    return AppMain;
});

